// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as CardTheme$OrcaPaymentPage from "../CardTheme.bs.js";
import * as CommonHooks$OrcaPaymentPage from "../Hooks/CommonHooks.bs.js";
import * as ElementType$OrcaPaymentPage from "../Types/ElementType.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as PortalState$OrcaPaymentPage from "../Hooks/PortalState.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "../Payments/VaultHelpers.bs.js";
import * as JotaiAtomTypes$OrcaPaymentPage from "../Types/JotaiAtomTypes.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./PaymentMethodCollectUtils.bs.js";

let keys = Jotai.atom(CommonHooks$OrcaPaymentPage.defaultkeys);

let configAtom = Jotai.atom(CardTheme$OrcaPaymentPage.defaultJotaiConfig);

let isConfigReady = Jotai.atom(false);

let portalNodes = Jotai.atom(PortalState$OrcaPaymentPage.defaultDict);

let elementOptions = Jotai.atom(ElementType$OrcaPaymentPage.defaultOptions);

let optionAtom = Jotai.atom(PaymentType$OrcaPaymentPage.defaultOptions);

let sessions = Jotai.atom("Loading");

let updateSession = Jotai.atom(false);

let isTokenize = Jotai.atom(false);

let paymentMethodList = Jotai.atom("Loading");

let sdkConfigs = Jotai.atom("Loading");

let loggerAtom = Jotai.atom(LoggerUtils$OrcaPaymentPage.defaultLoggerConfig);

let sessionId = Jotai.atom("");

let isConfirmBlocked = Jotai.atom(false);

let customPodUri = Jotai.atom("");

let selectedOptionAtom = Jotai.atom("");

let paymentTokenAtom = Jotai.atom(JotaiAtomTypes$OrcaPaymentPage.defaultPaymentToken);

let showPaymentMethodsScreen = Jotai.atom(false);

let vaultCredentials = Jotai.atom(VaultHelpers$OrcaPaymentPage.defaultVaultCredentials);

let cardCollectionMode = Jotai.atom("Tokenise");

let isBancontactCardFlow = Jotai.atom(false);

let cardFlowType = Jotai.atom("Payment");

let phoneJson = Jotai.atom("Loading");

let cardBrand = Jotai.atom("");

let supportedCardBrands = Jotai.atom(undefined);

let savedCardBrand = Jotai.atom("");

let optionsJsonAtom = Jotai.atom({});

let paymentOptionsJsonAtom = Jotai.atom({});

let cardBrandIconOverride = Jotai.atom(undefined);

let cvcIconOverride = Jotai.atom(undefined);

let cardNumberPlaceholder = Jotai.atom(undefined);

let cardExpiryPlaceholder = Jotai.atom(undefined);

let cardCvcPlaceholder = Jotai.atom(undefined);

let paymentMethodCollectOptionAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultPaymentMethodCollectOptions);

let payoutDynamicFieldsAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultPayoutDynamicFields(undefined));

let paymentMethodTypeAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultPmt(undefined));

let formDataAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultFormDataDict);

let validityDictAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultValidityDict);

let defaultFieldValues = {
  value: "",
  isValid: undefined,
  errorString: ""
};

let userFullName = Jotai.atom(defaultFieldValues);

let userEmailAddress = Jotai.atom(defaultFieldValues);

let newrecord = {...defaultFieldValues};

let userPhoneNumber = Jotai.atom((newrecord.countryCode = "", newrecord));

let userCardNickName = Jotai.atom(defaultFieldValues);

let isGooglePayReady = Jotai.atom(false);

let trustPayScriptStatus = Jotai.atom("NotLoaded");

let isApplePayReady = Jotai.atom(false);

let isSamsungPayReady = Jotai.atom(false);

let isVgsScriptReady = Jotai.atom(true);

let isSavedCardCvcFlow = Jotai.atom(false);

let userCountry = Jotai.atom("");

let userBank = Jotai.atom("");

let userAddressline1 = Jotai.atom(defaultFieldValues);

let userAddressline2 = Jotai.atom(defaultFieldValues);

let userAddressCity = Jotai.atom(defaultFieldValues);

let userAddressPincode = Jotai.atom(defaultFieldValues);

let userAddressState = Jotai.atom(defaultFieldValues);

let userAddressCountry = Jotai.atom(defaultFieldValues);

let userBlikCode = Jotai.atom(defaultFieldValues);

let userGiftCardNumber = Jotai.atom(defaultFieldValues);

let userGiftCardPin = Jotai.atom(defaultFieldValues);

let fieldsComplete = Jotai.atom(false);

let isManualRetryEnabled = Jotai.atom(false);

let userCurrency = Jotai.atom("");

let cryptoCurrencyNetworks = Jotai.atom("");

let isShowOrPayUsing = Jotai.atom(false);

let isShowOrPayUsingWhileLoading = Jotai.atom(false);

let areRequiredFieldsValid = Jotai.atom(true);

let areRequiredFieldsEmpty = Jotai.atom(false);

let saveDetailsCheckedAtom = Jotai.atom(false);

let dateOfBirth = Jotai.atom(null);

let userBillingName = Jotai.atom(defaultFieldValues);

let userVpaId = Jotai.atom(defaultFieldValues);

let userPixKey = Jotai.atom(defaultFieldValues);

let userPixCPF = Jotai.atom(defaultFieldValues);

let userPixCNPJ = Jotai.atom(defaultFieldValues);

let userDocumentType = Jotai.atom("");

let userDocumentNumber = Jotai.atom(defaultFieldValues);

let isCompleteCallbackUsed = Jotai.atom(false);

let isPaymentButtonHandlerProvidedAtom = Jotai.atom(false);

let userBankAccountNumber = Jotai.atom(defaultFieldValues);

let sourceBankAccountId = Jotai.atom(defaultFieldValues);

let defaultAreOneClickWalletsRendered = {
  isGooglePay: false,
  isApplePay: false,
  isPaypal: false,
  isKlarna: false,
  isSamsungPay: false
};

let areOneClickWalletsRendered = Jotai.atom(defaultAreOneClickWalletsRendered);

let defaultClickToPayConfig_availableCardBrands = [];

let defaultClickToPayConfig_consumerIdentity = {
  identityType: "EMAIL_ADDRESS",
  identityValue: ""
};

let defaultClickToPayConfig = {
  isReady: undefined,
  availableCardBrands: defaultClickToPayConfig_availableCardBrands,
  email: "",
  clickToPayCards: undefined,
  dpaName: "",
  clickToPayProvider: "NONE",
  visaComponentState: "NONE",
  maskedIdentity: "",
  otpError: "",
  consumerIdentity: defaultClickToPayConfig_consumerIdentity
};

let clickToPayConfig = Jotai.atom(defaultClickToPayConfig);

let defaultRedirectionFlags = {
  shouldUseTopRedirection: false,
  shouldRemoveBeforeUnloadEvents: false
};

let redirectionFlagsAtom = Jotai.atom(defaultRedirectionFlags);

let isTestMode = Jotai.atom(false);

let isUpdateIntentLoading = Jotai.atom(false);

export {
  keys,
  configAtom,
  isConfigReady,
  portalNodes,
  elementOptions,
  optionAtom,
  sessions,
  updateSession,
  isTokenize,
  paymentMethodList,
  sdkConfigs,
  loggerAtom,
  sessionId,
  isConfirmBlocked,
  customPodUri,
  selectedOptionAtom,
  paymentTokenAtom,
  showPaymentMethodsScreen,
  vaultCredentials,
  cardCollectionMode,
  isBancontactCardFlow,
  cardFlowType,
  phoneJson,
  cardBrand,
  supportedCardBrands,
  savedCardBrand,
  optionsJsonAtom,
  paymentOptionsJsonAtom,
  cardBrandIconOverride,
  cvcIconOverride,
  cardNumberPlaceholder,
  cardExpiryPlaceholder,
  cardCvcPlaceholder,
  paymentMethodCollectOptionAtom,
  payoutDynamicFieldsAtom,
  paymentMethodTypeAtom,
  formDataAtom,
  validityDictAtom,
  defaultFieldValues,
  userFullName,
  userEmailAddress,
  userPhoneNumber,
  userCardNickName,
  isGooglePayReady,
  trustPayScriptStatus,
  isApplePayReady,
  isSamsungPayReady,
  isVgsScriptReady,
  isSavedCardCvcFlow,
  userCountry,
  userBank,
  userAddressline1,
  userAddressline2,
  userAddressCity,
  userAddressPincode,
  userAddressState,
  userAddressCountry,
  userBlikCode,
  userGiftCardNumber,
  userGiftCardPin,
  fieldsComplete,
  isManualRetryEnabled,
  userCurrency,
  cryptoCurrencyNetworks,
  isShowOrPayUsing,
  isShowOrPayUsingWhileLoading,
  areRequiredFieldsValid,
  areRequiredFieldsEmpty,
  saveDetailsCheckedAtom,
  dateOfBirth,
  userBillingName,
  userVpaId,
  userPixKey,
  userPixCPF,
  userPixCNPJ,
  userDocumentType,
  userDocumentNumber,
  isCompleteCallbackUsed,
  isPaymentButtonHandlerProvidedAtom,
  userBankAccountNumber,
  sourceBankAccountId,
  defaultAreOneClickWalletsRendered,
  areOneClickWalletsRendered,
  defaultClickToPayConfig,
  clickToPayConfig,
  defaultRedirectionFlags,
  redirectionFlagsAtom,
  isTestMode,
  isUpdateIntentLoading,
}
/* keys Not a pure module */
